// extracted by mini-css-extract-plugin
module.exports = {"header":"CourseBackground_header__19Kc-","teachers":"CourseBackground_teachers__3PZ0D"};